module.exports = __webpack_public_path__ + "static/impact_3-a073698795b8fe74c01b864d4acc241a.png";